import { Button } from "../../primitives";
import { useState } from "react";
import Modal from "../../portals/Modal";
import Resubscribe from "../../popup/Resubscribe";
import DeleteWorkspace from "../../popup/DeleteWorkspace";
import SubscriptionInfo from "../../popup/SubscriptionInfo";
import { catchErrorParse } from "../../../ErrorUtility";
import { Accordion } from "../../primitives";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "../../../hooks/useTranslation";
import { useDatabase } from "../../../contexts/DatabaseContext";

export default function CanceledSubscription({ subscription, workspace, workspaceId, serviceIcon, loading, post, url, totalCost }) {
    const { createWorkspaceActionEvent, createSubscriptionActionEvent } = useDatabase();
    const { mobile, getInvoiceData, getBalance } = useOutletContext();
    const [states, setStates] = useState({
        isOpen: false,
        option: 0,
    });
    const t = useTranslation();

    async function handleResubscribeSubscription() {
        const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/subscriptions/re-subscribe`, {
            unsubbedSubscriptionItem: subscription,
        });
        if (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    code: errorCode,
                    message: errorMessage ? errorMessage : error.message,
                    action: "resubscribe",
                }
            }));
        } else {
            getInvoiceData();
            getBalance();
            createSubscriptionActionEvent("resubscribe", result.latest_invoice.total, workspace?.workspaceType, workspaceId);
        }
        setStates({ isOpen: false, option: 0 });
    }

    async function handleDeleteWorkspaceSubscription() {
        const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/subscriptions/del-workspace`, {
            unsubbedSubscriptionItem: subscription,
        });
        if (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    code: errorCode,
                    message: errorMessage ? errorMessage : error.message,
                    action: "delete",
                    diabolical: true,
                }
            }));
        } else {
            createWorkspaceActionEvent("delete", workspace?.workspaceType, workspaceId);
        }
        setStates({ isOpen: false, option: 0 });
    }

    return (
        <>
        {!mobile ? (
            <div className='workspace-subscription-grid'>
            <img src={serviceIcon} alt={workspace?.workspaceType} className='workspace-subscription-icon' />
            <h4 className='workspace-subscription-name'>{workspace?.workspaceName}</h4>
            <Button className='workspace-subscription-button cancel' onClick={() => setStates({ isOpen: true, option: 0 })}>{totalCost}</Button>
            <Button className='workspace-subscription-button' disabled={loading} loading={loading} onClick={() => setStates({ isOpen: true, option: 1 })}>{t('Resubscribe')}</Button>
            <Button className='workspace-subscription-button delete' disabled={loading} loading={loading} onClick={() => setStates({ isOpen: true, option: 2 })}>{t('Delete Workspace')}</Button>
            </div>
        ) : (
            <Accordion>
                <Accordion.Item>
                    <Accordion.Header>
                        <div className='workspace-subscription-row'>
                            <img src={serviceIcon} alt={workspace?.workspaceType} className='workspace-subscription-icon' />
                            <h4 className='workspace-subscription-name'>{workspace?.workspaceName}</h4>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className='workspace-subscription-col'>
                            <Button className='workspace-subscription-button cancel' onClick={() => setStates({ isOpen: true, option: 0 })}>{totalCost}</Button>
                            <Button className='workspace-subscription-button' disabled={loading} loading={loading} onClick={() => setStates({ isOpen: true, option: 1 })}>{t('Resubscribe')}</Button>
                            <Button className='workspace-subscription-button delete' disabled={loading} loading={loading} onClick={() => setStates({ isOpen: true, option: 2 })}>{t('Delete Workspace')}</Button>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )}
        <Modal open={states.isOpen} lock={loading} onClickOutside={() => setStates({ isOpen: false, option: 0 })}>
                {
                    states.option === 0 ? 
                        <SubscriptionInfo subscription={subscription} onClose={() => setStates({ isOpen: false, option: 0 })} totalCost={totalCost}/> : 
                    states.option === 1 ? 
                        <Resubscribe onConfirm={handleResubscribeSubscription} onCancel={() => setStates({ isOpen: false, option: 0 })} totalCost={totalCost}/> : 
                        <DeleteWorkspace onConfirm={handleDeleteWorkspaceSubscription} onCancel={() => setStates({ isOpen: false, option: 0 })}/>
                }
            </Modal>
        </>
    )
}
